<ng-template #template>
    <div class="ant-notification-notice-content">
        <div class="ant-notification-notice-with-icon">
            @if (icon()) {
                <span class="ant-notification-notice-icon p4">
                    <adspt-icon [name]="icon()" />
                </span>
            }
            <div class="ant-notification-notice-message a-fx a-fx-start-center a-fx-gap-16">
                <p class="p4">{{ title() }}</p>

                @if (action() && actionTxt()) {
                    <button class="a-fx-none toast-button" nz-button (click)="onActionClick()">
                        {{ actionTxt() | translate }}
                    </button>
                }
            </div>
        </div>
    </div>
</ng-template>
